export default (section, queryStr) => {
  //remove the leading '?' from queryStr
  if(queryStr.startsWith('?')) {
    queryStr = queryStr.substring(1);
  }
  const { hostname } = new URL(process.env.REACT_APP_CLIENT_BASE_URL); 
  const url = encodeURI(`${hostname}/client#/${section}/custom~yes|${queryStr}`);
  const urlScheme = `jamkazam://${url}`;
  return urlScheme;
};